<template>
  <section class="description-box">
    <div class="description">
      <div class="container container--description">
        <div class="description__text-box">
          <h2 class="description__name">{{ view.title }}</h2>
          <p v-if="view.author" class="description__subtitle">
            {{ view.author }}
          </p>
          <div class="description__text description__text--show">
            <p class="description__text-c">
              {{ view.displayedText }}
              <button
                v-if="view.hasLongText"
                class="description__toggle-full-text"
                @click="view.toggleShowFullText"
              >
                {{ toggleFullTextLabel }}
              </button>
            </p>
          </div>
        </div>
        <div class="description__img-box">
          <img class="description__img" :src="view.imageUrl" alt="" />
        </div>
      </div>
      <slot></slot>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ListDescriptionView } from '@/models/docs.list.description'

const props = defineProps<{
  view: ListDescriptionView
}>()

const toggleFullTextLabel = computed(() => {
  return props.view.showFullText ? 'Show less' : 'Show more'
})
</script>
